/**
 * Email obfuscation utility
 * Builds the upgrade email dynamically from character codes
 * to prevent simple static analysis and scraping
 */

// Character code arrays for email parts
const LOCAL_PART = [117, 112, 103, 114, 97, 100, 101]; // "upgrade"
const DOMAIN_NAME = [109, 97, 105, 108, 99, 114, 117, 110, 99, 104]; // "mailcrunch"
const TLD = [105, 111]; // "io"

const fromCodes = (codes: number[]): string =>
  codes.map((c) => String.fromCharCode(c)).join('');

/**
 * Constructs the upgrade email address at runtime
 * Returns: upgrade@mailcrunch.io
 */
export const getUpgradeEmail = (): string => {
  const local = fromCodes(LOCAL_PART);
  const at = String.fromCharCode(64); // @
  const domain = fromCodes(DOMAIN_NAME);
  const dot = String.fromCharCode(46); // .
  const tld = fromCodes(TLD);

  return `${local}${at}${domain}${dot}${tld}`;
};

/**
 * Creates a mailto link with pre-filled subject
 */
export const getUpgradeMailtoLink = (subject?: string): string => {
  const email = getUpgradeEmail();
  const defaultSubject = 'Upgrade to Mailcrunch Pro';
  const encodedSubject = encodeURIComponent(subject || defaultSubject);
  return `mailto:${email}?subject=${encodedSubject}`;
};
